<!-- список стран в виде блоков -->
<template>
	<div>
	<div class="w5-component-field-title" v-if="action !== 'create'">{{ 'datacenter/datacenter' | ftc }}:</div>
	<div v-if="items && items.length" class="w5-vds-plan-list-block country" :style="readonly ? 'opacity: 0.6' : null">
		<div v-for="item in items" 
			class="w5-vds-plan-list-item"
			:class="{ 'selected': item.id == curValue, 'disabled': item.active === false, 'readonly-item': this.readonly }"
			:key="item.id"
			@mouseover="mouseOver(item)"
			@mouseleave="mouseLeave"
			@click="onItemClick(item.id, item.active)">
				<div class="left-part">
					<span class="flag-icon" :class="'flag-icon-' + item['country']"></span>
				</div>
				<div class="right-part">
					<span class="name">{{ item['name'] | ftc }}</span>
				</div>
				<div v-show="showedTopHintId === item.id" class="w5-field-top-hint"><span v-withSafeTags="localeFtc('service/no_hardware')"></span></div>
		</div>
	</div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'countryComponent',
	//=========================================================================
	props: ['value', 'items', 'action', 'crud', 'readonly'],
	//=========================================================================
	data() {
		return {
			curValue: null,
			showedTopHintId: null
		}
	},
	//=========================================================================
	created() {
		if (this.crud === 'disks') {
			this.initValue()
		}
	},
	//=========================================================================
	methods: {
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// клик по тарифу
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onItemClick(id, enable) {
			if (this.readonly) return

			// эмуляция фокуса
			this.$emit('focus')
			// если заблокировано
			if (!enable) return
			// запоминаем новое значение
			this.curValue = String(id)
			// сообщаем родителю что у нас поменялось значение
			this.$emit('input', this.curValue)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// инициализация начального значения и форматирование списка
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		initValue() {
			// значение по умолчанию
			let value = null
			// ищем первый активный
			if (this.items && this.items.length)
			{
				this.items.some(item => {
					if (item.active === true && item.id)
					{
						value = String(item.id)
						return true
					}
				})
			}

			// текущее значение
			this.curValue = value
			this.$emit('input', this.curValue)
			this.$emit('startData', this.curValue)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик: навели курсор на итем
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		mouseOver(item) {
			if (!item || item.active) return
			if (this.showedTopHintId === item.id) return
			this.showedTopHintId = item.id
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик: убрали курсор с любого итема
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		mouseLeave() {
			this.showedTopHintId = null
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
	},
	//=========================================================================
	watch: {
		'value': function(value) {
			this.curValue = String(value)
		},
		// если изменился список - перегрузили его
		'items': function(items) {
			this.initValue()
		}
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.w5-field-top-hint {
	position: absolute;
    bottom: 39px;
    padding: 10px;    
	border-radius: 4px;
	font-size: 13.5px;
	font-weight: 300;
	background: #fff5ee;
	border: 1px solid #f9caa7;
	margin-left: -11px;
	color: #333;
}
.w5-field-top-hint::before, .w5-field-top-hint::after {
	content: '';
	position: absolute;
	left: 20px; bottom: -10px;
	border: 5px solid transparent;
	border-top: 5px solid #f9caa7;
}
.w5-field-top-hint::after {
	border-top: 5px solid #fff5ee;
	bottom: -8px; 
}
</style>

<style>
.w5-vds-plan-list-block.country {
	margin-top: 10px;
	justify-content: flex-start;
	-webkit-justify-content: flex-start;
}

.w5-vds-plan-list-block.country .w5-vds-plan-list-item {
	position: relative;
	height: 40px;
	text-align: left;
	padding: 0 10px;
	margin: 10px 15px 10px 0;
	width: 280px;
	border: 1px solid #ddd;
	border-radius: 4px;
    transition: background-color .2s;
    transition: border-color .2s;
}

.w5-vds-plan-list-block.country .w5-vds-plan-list-item.selected,
.w5-vds-plan-list-block.country .w5-vds-plan-list-item:hover {
	background-color: #dceeff;
    border-color: #2c8ad8;
}
.w5-application.mc .w5-vds-plan-list-block.country .w5-vds-plan-list-item.selected,
.w5-application.mc .w5-vds-plan-list-block.country .w5-vds-plan-list-item:hover {
    border-color: #01196f;
}

.w5-vds-plan-list-block.country .w5-vds-plan-list-item.disabled {
	background-color: #eee !important;
    border-color: #ccc !important;
    color: #aaa;
}

.w5-vds-plan-list-block.country .w5-vds-plan-list-item.selected.disabled {
	cursor: not-allowed;
	opacity: 0.6;
}

.w5-vds-plan-list-block.country .w5-vds-plan-list-item .left-part {
	float: left;
	width: 24px;
	height: 38px;
}
.w5-vds-plan-list-block.country .w5-vds-plan-list-item .right-part {
	float: right;
	width: 225px;
	height: 38px;
}

.w5-vds-plan-list-block.country .flag-icon {
	width: 24px;
	height: 18px;
	background-size: cover;
	margin-top: 10px;
	border: 1px solid #eee;
}

.w5-vds-plan-list-block.country .name {
	display: table-cell;
	vertical-align: middle;
	height: 38px;
	font-weight: 500;
	line-height: 1.1;
}

@media (max-width: 767px) {
	.w5-vds-plan-list-block.country .w5-vds-plan-list-item {
		width: 220px;
	}
	.w5-vds-plan-list-block.country .w5-vds-plan-list-item .right-part {
		width: 165px;
	}
}
</style>



// WEBPACK FOOTER //
// country.vue?71dbcf22